import { render, staticRenderFns } from "./CreditTransactionsDialog.vue?vue&type=template&id=52cdb20e&scoped=true"
import script from "./CreditTransactionsDialog.vue?vue&type=script&lang=js"
export * from "./CreditTransactionsDialog.vue?vue&type=script&lang=js"
import style0 from "./CreditTransactionsDialog.vue?vue&type=style&index=0&id=52cdb20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdb20e",
  null
  
)

export default component.exports